import { BaseClient } from '../client';
import { TConcessionariaRevendaDesvincularDTO } from './concessionariaRevenda.types';

interface ApiResponse<T> {
	success: boolean;
	message: string;
	data: T;
}

export const deleteDesvincular = async (dto: TConcessionariaRevendaDesvincularDTO) => {
	try {
		const response = await BaseClient.delete<ApiResponse<string>>(
			`v2/ConcessionariaRevenda/Desvincular`,
			{ data: dto }
		);

		return response.data.message;
	} catch (error) {
		console.error(error);
		throw error;
	}
};
